import { Component, EventEmitter, Injectable, OnInit, Output } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment.dev';


const headers = new HttpHeaders({
  'x-no-notification': 'true'
});



@Injectable({
  providedIn: 'root'
})
export class EmojiDataService {
  public data: any = [];
  public developers: any = [];

  constructor(private http: HttpClient) {}

  list( ): Observable<any> {
    return this.http.get<any>(`/assets/emoji.json`, {
      headers
    });
  }
}

@Component({
  selector: 'app-emoji-selector',
  templateUrl: './emoji-selector.component.html',
  styleUrls: ['./emoji-selector.component.scss']
})
export class EmojiSelectorComponent implements OnInit {
  @Output() emojiChange = new EventEmitter<any>();
  isModalVisible = false;
  selectedEmoji:string;
  emojiList: any = [];
  constructor(
    private emojiDataService: EmojiDataService,
  ) { }

  ngOnInit(): void {
    this.emojiDataService.list().subscribe(response => {
      this.emojiList = response.files;
    });
  }

  showEmojiModal() {
    this.isModalVisible = true;
  }

  getEmojiUrl(emoji: string): string {
    return `/assets/images/emoji/${emoji}`;
  }

  selectEmoji(emoji: string) {
    this.selectedEmoji = emoji;
    this.isModalVisible = false;
    this.emojiChange.emit(emoji);
  }
}
